import { useEffect } from 'react';
import { useModal } from '../../contexts/modal';
import { useVersionCheck } from '../../helpers/use-version-check';
import { saveAutoResumePlayback } from '../../helpers/auto-resume';
import { useAppSelector } from '../../state/hooks';
import { WebId } from '../../slices/local/orchestrator';
import { NewVersionModal } from '../dialogs/NewVersionModal';

export const VersionWatcher = () => {
  const { showModal } = useModal();
  const { isNewVersionAvailable, dismissVersionPrompt } = useVersionCheck();

  const webChannelState = useAppSelector(state => state?.orchestrator?.players?.[WebId]?.channels?.[1]);
  const isLocalPlaying = !!(webChannelState?.queue?.entries?.some(e => e.playing));
  const stationId = webChannelState?.stationId;

  useEffect(() => {
    if (isNewVersionAvailable) {
      showModal(NewVersionModal, {
        isLocalPlaying,
        onReload: () => {
          if (isLocalPlaying && stationId) {
            saveAutoResumePlayback({
              playerId: WebId,
              channel: 1,
              stationId
            });
          }
          window.location.reload();
        },
        onCancel: () => {
          dismissVersionPrompt();
        }
      });
    }
  }, [isNewVersionAvailable, isLocalPlaying, stationId]);

  return null;
};
